var _defs, _rect, _path, _rect2, _text, _text2, _rect3, _rect4, _rect5, _rect6, _text3, _text4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoverPosInventory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1200,
    height: 760,
    viewBox: "0 0 1200 760",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-label": "POS inventory system",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#111827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#1f2937"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 760,
    fill: "url(#bg)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 640C220 520 340 730 560 650C760 580 930 740 1200 640V760H0Z",
    fill: "#f97316",
    opacity: 0.16
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 110,
    width: 1020,
    height: 540,
    rx: 30,
    fill: "#0b1220",
    stroke: "#f59e0b",
    strokeOpacity: 0.42
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 150,
    y: 210,
    fill: "#f8fafc",
    fontFamily: "Segoe UI, Arial, sans-serif",
    fontSize: 46,
    fontWeight: 800
  }, "POS &amp; INVENTORY")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 150,
    y: 250,
    fill: "#cbd5e1",
    fontFamily: "Segoe UI, Arial, sans-serif",
    fontSize: 24
  }, "Stock, supplier, sales report, outlet workflow")), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 320,
    width: 90,
    height: 190,
    rx: 12,
    fill: "#f97316"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 270,
    y: 370,
    width: 90,
    height: 140,
    rx: 12,
    fill: "#fb923c"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 390,
    y: 290,
    width: 90,
    height: 220,
    rx: 12,
    fill: "#fdba74"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 530,
    y: 320,
    width: 500,
    height: 190,
    rx: 16,
    fill: "#111827",
    stroke: "#475569"
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 560,
    y: 382,
    fill: "#f8fafc",
    fontFamily: "Segoe UI, Arial, sans-serif",
    fontSize: 24,
    fontWeight: 700
  }, "NestJS   MySQL   TypeORM")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 560,
    y: 426,
    fill: "#cbd5e1",
    fontFamily: "Segoe UI, Arial, sans-serif",
    fontSize: 20
  }, "Swagger  Jenkins  Docker")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoverPosInventory);
export default __webpack_public_path__ + "static/media/cover-pos-inventory.756dffd5d34f0e52606166be2ddad026.svg";
export { ForwardRef as ReactComponent };